import { render, staticRenderFns } from "./add-location-category.vue?vue&type=template&id=3d9847d0"
import script from "./add-location-category.vue?vue&type=script&lang=js"
export * from "./add-location-category.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports